import React from 'react';
import { useTranslation } from 'react-i18next';
import { errorTextClass } from './inputClasses';
import { resolveValidationMessage } from 'helpers/validationMessages';

// Renders a field-level validation error.
//
// This is one of exactly two places that resolve a zod message, which is what
// lets ~500 schema constraints become translatable without any of them
// becoming a hook: a schema carries a KEY ('validation.required'), evaluated
// harmlessly at module scope, and the resolution happens here at render time
// in the active language. A message that is not a known key passes through
// untouched, so converted and unconverted schemas coexist.
export default function ErrorText({ children }) {
  const { t } = useTranslation('common');
  if (!children) return null;
  return <p className={errorTextClass}>{resolveValidationMessage(children, t)}</p>;
}
